import AboutMe_2 from '../components/AboutMe_2';

function HomePage() {
    return (
        <>
            <AboutMe_2 />
        </>
    );
}

export default HomePage;